/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

import React from 'react';
import './styles.scss';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import pinIcon from '../../Images/Marker.png';

/**
 * Marker Component
 * @param props
 * @returns {Element}
 * @constructor
 */
export function Marker(props) {
  const { alt, onClick } = props;

  /**
     * Render the studio map marker
     * @returns {JSX.Element}
     */
  return (
    <Box className="map-marker" onClick={onClick}>
      <img src={pinIcon} alt={alt} />
    </Box>
  );
}

Marker.propTypes = {
  alt: PropTypes.string,
  onClick: PropTypes.func,
};

Marker.defaultProps = {
  alt: '',
  onClick: null,
};
